import React, { FC, memo } from 'react';

import { ADDRESS_REPORT_POINTS_SKELETON_ROWS_COUNT, DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportAddressOption from '../ReportAddressOption';
import type { AddressOptionsListProps } from './types';

import styles from '../index.module.scss';

const AddressOptionsList: FC<AddressOptionsListProps> = ({
  addresses,
  isLoading,
  selectedAddressIdSet,
  onAddressChange,
}) => (
  <ul
    className={styles.list}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_LIST}>
    {isLoading &&
      Array.from({ length: ADDRESS_REPORT_POINTS_SKELETON_ROWS_COUNT }, (_, index) => (
        <li
          key={index}
          className={styles.skeletonItem}
          data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SKELETON_ROW(index)}>
          <span className={styles.skeletonCheckbox} />
          <span className={styles.skeletonContent}>
            <span className={styles.skeletonLine} />
            <span className={styles.skeletonLineShort} />
          </span>
        </li>
      ))}

    {!isLoading &&
      addresses.map((address) => (
        <ReportAddressOption
          key={address.id}
          address={address}
          isChecked={selectedAddressIdSet.has(address.id)}
          onChange={onAddressChange}
        />
      ))}

    {!isLoading && addresses.length === 0 && (
      <li
        className={styles.empty}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_EMPTY}>
        {TEXTS.AUDIO_REPORT_ADDRESSES_EMPTY}
      </li>
    )}
  </ul>
);

export default memo(AddressOptionsList);
